import { useLocation, useNavigate } from "react-router-dom";
import { Phone, MessageSquare, ClipboardList } from "lucide-react";
import useContactInfo from "../lib/useContact";
import { track } from "../lib/track";

/** Mobile-only sticky action bar: CALL · TEXT · FREE ESTIMATE */
export default function StickyMobileCTA() {
  const { pathname } = useLocation();
  const nav = useNavigate();
  const biz = useContactInfo();
  if (pathname.startsWith("/admin")) return null;

  const smsHref = biz.phoneMainHref.replace("tel:", "sms:");
  const goEstimate = () => {
    if (pathname === "/contact") {
      document.querySelector('[data-testid="lead-form"]')?.scrollIntoView({ behavior: "smooth", block: "start" });
    } else {
      nav("/contact");
    }
  };

  return (
    <nav
      data-testid="sticky-mobile-cta"
      aria-label="Quick actions"
      className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-[#111]/95 backdrop-blur border-t border-white/10 grid grid-cols-3"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a
        href={biz.phoneMainHref}
        data-testid="sticky-call-btn"
        onClick={() => track("click_to_call", { location: "sticky_bar" })}
        className="flex flex-col items-center justify-center gap-1 py-2.5 text-white/90 active:bg-white/10"
      >
        <Phone size={17} />
        <span className="text-[10px] font-semibold tracking-[0.2em]">CALL</span>
      </a>
      <a
        href={smsHref}
        data-testid="sticky-text-btn"
        onClick={() => track("click_to_text", { location: "sticky_bar" })}
        className="flex flex-col items-center justify-center gap-1 py-2.5 text-white/90 active:bg-white/10 border-x border-white/10"
      >
        <MessageSquare size={17} />
        <span className="text-[10px] font-semibold tracking-[0.2em]">TEXT</span>
      </a>
      <button
        onClick={goEstimate}
        data-testid="sticky-estimate-btn"
        className="flex flex-col items-center justify-center gap-1 py-2.5 bg-[#C27A3E] text-white active:bg-[#99582A]"
      >
        <ClipboardList size={17} />
        <span className="text-[10px] font-semibold tracking-[0.2em]">FREE ESTIMATE</span>
      </button>
    </nav>
  );
}
